import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { ApiConstants } from '../constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class LocationsService {
  locationsList = [];
  storageLocationsList = [];
  constructor(private httpClient: HttpClient) {

  }
  // Need to do Update with LocationsType
  getLocations(): Observable<any> {
    let observable: Observable<any>;
    if (this.locationsList.length > 0) {
      observable = of(this.locationsList);
    }
    else {
      observable = this.httpClient.get<any>(ApiConstants.Locations_Api)
        .pipe(
          tap(locationsData => this.locationsList = locationsData)
        );
    }
    return observable;
  }

  getStorageLocations(): Observable<any> {
    let observable: Observable<any>;
    if (this.storageLocationsList.length > 0) {
      observable = of(this.storageLocationsList);
    }
    else {
      observable = this.httpClient.get<any>(ApiConstants.StorageLocations_Api)
        .pipe(
          tap(storageLocationsData => this.storageLocationsList = storageLocationsData)
        );
    }
    return observable;
  }
}
